import * as React from "react";

import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
} from "./drawer";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "./Dialog";

import { useResponsive } from "@shared/hooks/responsive/use-responsive";

function buildResponseComponent<
  A extends React.FC<any>,
  B extends React.FC<any>
>(
  mobile: A,
  desktop: B,
) {
  const render: React.FC<React.ComponentProps<A> & React.ComponentProps<B>> = (
    props: React.ComponentProps<A> & React.ComponentProps<B>
  ) => {
    const { isGreaterThanTablet } = useResponsive();
    const Component = !isGreaterThanTablet ? mobile : desktop;

    return <Component {...props} />;
  };

  return render;
}

const Modal = buildResponseComponent(Drawer, Dialog);
const ModalTrigger = buildResponseComponent(DrawerTrigger, DialogTrigger);
const ModalPortal = (props) => {
  console.log(Modal);
  return Modal === Drawer ? DrawerPortal : DialogPortal
};
const ModalClose = buildResponseComponent(DrawerClose, DialogClose);
const ModalOverlay = buildResponseComponent(DrawerOverlay, DialogOverlay);
const ModalContent = buildResponseComponent(DrawerContent, DialogContent);
const ModalHeader = buildResponseComponent(DrawerHeader, DialogHeader);
const ModalFooter = buildResponseComponent(DrawerFooter, DialogFooter);
const ModalTitle = buildResponseComponent(DrawerTitle, DialogTitle);
const ModalDescription = buildResponseComponent(
  DrawerDescription,
  DialogDescription,
);

export {
  Modal,
  ModalPortal,
  ModalOverlay,
  ModalClose,
  ModalTrigger,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalTitle,
  ModalDescription,
};
